import { ajaxErrorAlert, ajaxPost } from "./utils";
import { getJsContext } from "../app";
import { openIframePopup } from "./common";

const body = $("body");

if (body.hasClass("property")) {
  const compulsoryPropertyForm = $("#compulsoryPropertyForm");

  compulsoryPropertyForm.on("submit", (e) => {
    e.preventDefault();

    const form = $(e.target);
    const data = form.serializeArray();
    data.push({
      name: "action",
      value: "get_iframe_url",
    });
    form.loading({
      loadingText: getJsContext("please_wait") + "...",
      action: "show",
      extraClasses: "spinner-fixed",
    });
    ajaxPost("", data, form)
      .then((response) => {
        openIframePopup("ISB", response["iframe_url"]);
      })
      .catch((errors) => {
        ajaxErrorAlert(errors, form);
      });
  });

  const paymentDetailFields = $(".paymentDetailFields");
  if (paymentDetailFields.length) {
    paymentDetailFields.show();
    ajaxPost("", { action: "get_payment_details" })
      .then((response) => {
        paymentDetailFields.find(".paymentDetailLoadingSpinner").remove();
        paymentDetailFields
          .find('input[name="payment_code"]')
          .val(response["payment_code"]);
        paymentDetailFields
          .find('input[name="payment_amount"]')
          .val(response["payment_amount"]);
      })
      .catch((errors) => {
        paymentDetailFields.hide();
        console.error(
          "An error occurred while getting payment details:",
          errors,
        );
      });
  }
}
